// @flow
import JPlace from './JPlace';

export default JPlace;
